export interface SiteMeta {
	name: string;
	summary: string;
}

export const siteMeta: SiteMeta = {
	name: "Sand and Sun Travels LLC",
	summary: "Sand and Sun Travels LLC is a Denver-based travel agency dedicated to turning your travel dreams into unforgettable experiences. We specialize in Caribbean cruises, all-inclusive resorts, luxury yacht voyages, and custom vacation planning tailored to your unique style and budget.",
};
